import { MainvenueResType, MarkInfoItemType, SkuInfoItemType, VenueItemResType } from './types'
import dayjs from 'dayjs'

// function getTodayInfo(list: Omit<MarkInfoItemType, 'begTime' | 'endTime'>[]): MarkInfoItemType[] {
//   return list.map()
// }

const skuInfo: SkuInfoItemType = {
  biddingNo: '11111',
  imgUrl: '',
  marketingPrice: '111',
  noticeFlag: 2,
  orderNo: 1111,
  salePrice: '100',
  skuId: 1,
  skuProperty: 'White Red US6',
  spuId: 1,
  stock: 10,
  totStock: 10,
  title: 'Air Jordan 1 Retro High OG “Origin Story” 芝加哥 蜘蛛侠 GS 美版 芝加哥 蜘蛛侠 GS 美版',
}

function getRandomNum(num = 10) {
  return Math.floor(Math.random() * num)
}

function getSkuInfoList(num: number, venueId: number) {
  return new Array(num).fill(1).map((e, index) => ({
    ...skuInfo,
    spuId: index,
    skuId: index,
    title: `${skuInfo.title}-${venueId}-${index}`,
    stock: getRandomNum(10),
    noticeFlag: getRandomNum(2) as 1 | 2,
  }))
}

const martInfo: Omit<MarkInfoItemType, 'venueSkuInfoList' | 'endTime' | 'begTime'> = {
  jumpUrl: 'https://www.poizon.com/',
  venueId: 11,
  stockFlag: 1,
  // venueSkuInfoList,
}

function getMartInfoItem(i: number) {
  const dateStr = dayjs().format('YYYY-MM-DD')
  return {
    ...martInfo,
    // @ts-ignore
    begTime: dayjs(`${dateStr} ${11 + i}:49`).$d.getTime(),
    // @ts-ignore
    endTime: dayjs(`${dateStr} ${12 + i}:49`).$d.getTime(),
    venueId: i,
    venueSkuInfoList: getSkuInfoList(getRandomNum(10), i),
  }
}

function getMartInfoList(num: number): MarkInfoItemType[] {
  return new Array(num).fill(1).map((e, i) => getMartInfoItem(i))
}

export const mainvenueRes: MainvenueResType = {
  data: {
    markInfoList: getMartInfoList(4),
    status: 200,
  },
}

export const venueItemRes: VenueItemResType = {
  data: {
    ...getMartInfoItem(1),
    stockFlag: 3,
  },
  code: 200,
}

export function getVenueItemRes(venueId: number) {
  return {
    data: {
      ...getMartInfoItem(venueId),
      stockFlag: getRandomNum(4),
    },
    code: 200,
  }
}
